// ============================================
// TRADUCCIONES ESPAÑOL (ES)
// ============================================

import { registerTranslations } from "../LanguageContext";

const es = {
  // Header / Contacto
  "contact.email": "Correo electrónico",
  "contact.phone": "Teléfono",
  "contact.linkedin": "LinkedIn",
  "contact.github": "GitHub",
  "header.subtitle": "Actualmente aprendiendo arquitectura de software utilizando ecosistemas de agentes de IA y MCP de forma autodidacta.",

  // Secciones principales
  "section.about": "Sobre Mí",
  "section.experience": "Experiencia Laboral",
  "section.education": "Educación",
  "section.skills": "Habilidades",
  "section.certifications": "Certificaciones",
  "section.languages": "Idiomas",
  "section.softSkills": "Aptitudes Personales",
  "section.projects": "Proyectos en GitHub",
  "section.interests": "Intereses",
  "section.tools": "Herramientas",
  "section.frontend": "Frontend",
  "section.backend": "Backend",

  // Sobre mí
  "section.about.content": "Arquitecto de software con más de 5 años de conocimiento y más de dos años de experiencia en el sector como programador FullStack Developer. Durante mi recorrido he tenido la oportunidad de desarrollar, tanto en solitario como en grupo, grandes proyectos utilizando diferentes tecnologías y sacándoles el máximo partido.",
  
  // Experiencia 1
  "section.experience.first.title": "FP Dual Técnico Informático",
  "section.experience.first.date": "Abril 2021 - Jun 2022",
  "section.experience.first.location": "Cambrils, España",
  "section.experience.first.skill.one": "Mantenimiento y gestión de CMS (Wordpress, Prestashop)",
  "section.experience.first.skill.two": "Gestión de servidor local (Windows)",

  // Experiencia 2
  "section.experience.second.title": "Técnico Informático Contrato Indefinido",
  "section.experience.second.date": "Jun 2022 - Sep 2022",
  "section.experience.second.location": "Cambrils, España",
  "section.experience.second.skill.one": "Mantenimiento y gestión de CMS (Wordpress, Prestashop)",
  "section.experience.second.skill.two": "Gestión de servidor local (Windows)",
  "section.experience.second.skill.three": "Creación y gestión de campañas publicitarias con RRSS",

  // Experiencia 3
  "section.experience.third.title": "FP Dual Backend Developer",
  "section.experience.third.date": "Feb 2023 - Abril 2024",
  "section.experience.third.location": "Remoto",
  "section.experience.third.skill.one": "Mantenimiento y creación de aplicaciones web utilizando CMS (Wordpress, Prestashop, Drupal)",
  "section.experience.third.skill.two": "Creación de módulos para Drupal",
  "section.experience.third.skill.three": "Gestión de plataformas de autoalojamiento de archivos (NextCloud)",

  // Experiencia 4
  "section.experience.forth.title": "Junior FullStack Developer",
  "section.experience.forth.date": "Sep 2024 - Dic 2025",
  "section.experience.forth.location": "Remoto",
  "section.experience.forth.skill.one": "Proyectos de pruebas de software en solitario (Selenium, Cypress, PhpUnit)",
  "section.experience.forth.skill.two": "Mantenimiento y creación de aplicaciones web utilizando CMS (Wordpress, Prestashop, Drupal)",
  "section.experience.forth.skill.three": "Creación de módulos para Drupal",
  "section.experience.forth.skill.four": "Creación de software para gestión de empresas (ObjectScript + React)",
  "section.experience.forth.skill.five": "Creación de sistema de reservas con conectores externos (ObjectScript)",
  "section.experience.forth.skill.six": "Mantenimiento de librerías para nuevas versiones de Java",
  "section.experience.forth.skill.seven": "Gestión de plataformas de autoalojamiento de archivos (NextCloud)",

  // Education 1
  "section.education.first.title": "Grado Superior en Desarrollo de Aplicaciones Multiplataforma",

  // Education 2
  "section.education.second.title": "Grado Medio en Sistemas Microinformáticos y Redes",

  // Education 3
  "section.education.third.title": "Educación Secundaria Obligatoria (ESO)",

  // Certificado 1
  "section.certifications.first.title": "Certificado AngularJS 1x",

  // Certificado 2
  "section.certifications.second.title": "Certificado React",

  // Certificado 3
  "section.certifications.third.title": "Certificado Iniciación al Desarrollo con IA",

  // Certificaciones
  "cert.view": "Ver credencial",

  // Soft Skills
  "softSkill.one": "Creatividad",
  "softSkill.two": "Motivación",
  "softSkill.three": "Gran trabajo en equipo",
  "softSkill.four": "Independencia",
  "softSkill.five": "Buena toma de decisiones",
  "softSkill.six": "Constancia",
  "softSkill.seven": "Responsabilidad",
  "softSkill.eight": "Disciplina",
  "softSkill.nine": "Determinación",

  // Interests
  "interests.one": "Desarrollo Web",
  "interests.two": "Arquitectura de Software",
  "interests.three": "Aprendizaje Continuo",

  // Proyectos
  "project.public": "Público",
  "project.private": "Privado",
  "project.viewRepo": "Ver repositorio",
  "project.loading": "Cargando repositorios...",
  "project.error": "Error al cargar repositorios",
  "project.empty": "No se encontraron repositorios públicos",
  "project.viewAll": "Ver todos",

  // CV Download
  "cv.download": "Descargar CV (PDF)",

  // Estados
  "status.loading": "Cargando...",
  "status.error": "Error",
  "status.empty": "Sin datos",

  // Footer
  "footer.madeWith": "Hecho con React + TypeScript",

  // Language
  "language.es": "Español",
  "language.en": "Inglés",
  "language.ca": "Catalán",

  // Language Selector
  "language.select": "Selecciona un idioma",
  "language.selector.es": "Español",
  "language.selector.en": "English",

  // Language levels
  "language.level.native": "Nativo",
  "language.level.b2": "Muy Alto (Certificado Cambridge B2)",
  "language.level.veryHigh": "Muy Alto",


  // Errores
  "error.generic": "Algo salió mal",
  "error.retry": "Reintentar",
};

registerTranslations("es", es);

export default es;